import request from '@/utils/request'

// 邀请
export function Invitation (params) {
  return request({
    url: 'post/personnel/Invitation',
    data: params
  })
}

export function GetTeamUser (params) {
  return request({
    url: 'post/personnel/GetTeamUser',
    data: params
  })
}

export function MoveOutOfTeam (params) {
  return request({
    url: 'post/personnel/MoveOutOfTeam',
    data: params
  })
}

export function SetTeamAdminUser (params) {
  return request({
    url: 'post/personnel/SetTeamAdminUser',
    data: params
  })
}



// WEBPACK FOOTER //
// ./src/api/personnel.js